import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import Providers from './Providers';
import reportWebVitals from './reportWebVitals';

// Set the base URL for the API
const environment = process.env.REACT_APP_NODE_ENV || 'dev';

export const apiBaseUrl =
  environment === 'prod'
    ? 'https://apim-notewell-prod-wusx.azure-api.net/api/'
    : process.env.REACT_APP_NODE_ENV === 'staging'
      ? 'https://appcs-backend-dev-wus-001.azurewebsites.net'
      : 'http://localhost:8080';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
